import { render, staticRenderFns } from "./CalculationTooltip.vue?vue&type=template&id=31b28b2c&scoped=true"
import script from "./CalculationTooltip.vue?vue&type=script&lang=js"
export * from "./CalculationTooltip.vue?vue&type=script&lang=js"
import style0 from "./CalculationTooltip.vue?vue&type=style&index=0&id=31b28b2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b28b2c",
  null
  
)

export default component.exports